import { useTranslation } from "react-i18next";
import { Popup } from "../Popup";
import { LegalContent } from "./LegalContent";
import { useStore } from "../../store/globalState";
import type { LegalDocKey } from "../../constants/legal";

interface LegalModalProps {
  doc: LegalDocKey;
  visible: boolean;
  onClose: () => void;
}

export const LegalModal: React.FC<LegalModalProps> = ({
  doc,
  visible,
  onClose,
}) => {
  const { t } = useTranslation();
  const { bodyCopy } = useStore().theme.whiteView;

  return (
    <Popup visible={visible} onClose={onClose}>
      <div className="legal-modal-content" style={{ color: bodyCopy }}>
        <p className="legal-modal-title">{t(`legal.docs.${doc}`)}</p>
        <LegalContent doc={doc} thumbColor={bodyCopy} />
      </div>
    </Popup>
  );
};
